import axios from 'axios';

export default {
    updateApiToken(user)
    {
        if(user === null || user.api_token === null || user.api_token === undefined)
        {
            delete axios.defaults.headers.common.Authorization;
        }
        else
        {
            axios.defaults.headers.common.Authorization = 'Bearer ' + user.api_token;
        }
    }
}
